import React, { forwardRef, useEffect, useRef, useState } from "react";

import { useDebounce } from "usehooks-ts";

interface Props {
  value: string;
  onChange(val: string): void;
  onFocus(): void;
  onBlur(): void;
}

export const DebouncedInput = forwardRef<HTMLInputElement, Props>(
  ({ value: providedValue, onChange, onFocus, onBlur }, ref) => {
    const isInitialRef = useRef(true);
    const [value, setValue] = useState("");

    useEffect(() => {
      setValue(providedValue);
    }, [providedValue]);

    const debouncedValue = useDebounce(value, 1000);

    useEffect(() => {
      if (!isInitialRef.current) {
        onChange(debouncedValue);
      }

      isInitialRef.current = false;
    }, [debouncedValue]);

    return (
      <input
        ref={ref}
        type="text"
        className="text-sm font-normal py-[5px] w-full placeholder:font-light mr-1"
        placeholder="Search..."
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    );
  },
);
